{
  "title": "Haste",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level transmutation",
  "level": 3,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a shaving of licorice root)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Choose a willing creature that you can see within range. Until the spell ends, the target’s speed is doubled, it gains a +2 bonus to AC, it has advantage on Dexterity saving throws, and it gains an additional action on each of its turns. That action can be used only to take the Attack (one weapon attack only), Dash, Disengage, Hide, or Use an Object action.",
    "When the spell ends, the target can’t move or take actions until after its next turn, as a wave of lethargy sweeps over it."
  ],
  "spellLists": ["artificer", "sorcerer", "wizard"]
}
